/**
 * @file localstorageを扱うためのUtility関数群
 */

/**
 * localStorageに値を設定する
 * @param key {string}
 * @param value {any}
 * @param expire {string}
 */
const setStorage = (key, value, expire) => {
  let data

  // expireを設定するときはJSON形式で登録する
  if (expire !== undefined) {
    data = {
      expire: expire,
      value: value,
    }
    localStorage.setItem(key, JSON.stringfy(data))
  } else {
    data = value
    localStorage.setItem(key, data)
  }
}

/**
 * localStorageから値を取得する
 * @param key {string}
 */
const getStorage = (key) => {
  let s = localStorage[key]

  if (s === undefined) {
    return undefined
  }

  // expireを設定しているときはJSON形式で返ってくる
  // なので、expireを設定していない場合と条件分岐させる必要がある
  if (typeof s === 'object') {
    s = JSON.parse(s)
    if (new Date(s.expire) > new Date()) {
      return s.value
    } else {
      localStorage.removeItem(key)

      return undefined
    }
  } else {
    return s
  }
}

/**
 * localStorageから値を削除する
 * @param key {string}
 */
const removeStorage = (key) => {
  const s = localStorage[key]

  if (s === undefined) {
    return undefined
  }

  localStorage.removeItem(key)
}

export { setStorage, getStorage, removeStorage }
